import type { HttpErrorResponse } from '@angular/common/http';

import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import {
  IGroupEnrollment,
  type IGroupEnrollmentUpdate,
} from 'src/app/shared/interfaces/group-enrollment/group-enrollment.interface';
import { AlertService } from 'src/app/shared/services/alert.service';
import { GroupEnrollmentService } from 'src/app/shared/services/group-enrollment/insurance/group-enrollment.service';

@Component({
  selector: 'app-edit-group-enrollment-casenumber',
  templateUrl: './edit-group-enrollment-casenumber.component.html',
})
export class EditGroupEnrollmentCasenumberComponent
  implements OnInit, OnDestroy
{
  @Input() groupEnrollment: IGroupEnrollment;

  caseNumberForm: UntypedFormGroup;
  groupEnrollmentID: string;

  caseNumbers: string[];
  isLoading: boolean;

  private subscriptions: Subscription = new Subscription();

  constructor(
    private activeModal: NgbActiveModal,
    private fb: UntypedFormBuilder,
    private groupEnrollmentService: GroupEnrollmentService,
    private alertService: AlertService,
  ) {}

  ngOnInit() {
    this.groupEnrollmentID = this.groupEnrollment.id;

    this.caseNumbers = [this.groupEnrollment.caseNumber];

    this.caseNumberForm = this.fb.group({
      caseNumber: [
        this.groupEnrollment.caseNumber || '',
        [Validators.required],
      ],
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  save() {
    const formValue: IGroupEnrollmentUpdate = {
      ...this.groupEnrollment,
      ...this.caseNumberForm.value,
    };

    this.isLoading = true;

    this.subscriptions.add(
      this.groupEnrollmentService.editGroupEnrollment(formValue).subscribe({
        next: () => {
          const successMessage = `Case Number(s) for ${this.groupEnrollmentID} has been updated successfully!`;

          this.isLoading = false;
          this.alertService.success(successMessage);
          this.activeModal.close();
        },
        error: (error: unknown) => {
          this.isLoading = false;
          this.alertService.error(error as HttpErrorResponse | string);
        },
      }),
    );
  }

  close() {
    this.activeModal.dismiss();
  }
}
